export default __webpack_public_path__ + "static/media/newrelic.978dfdc2.svg";